module.exports = __webpack_public_path__ + "static/media/-ve-heroes.62183581.png";